import { Col, Row } from "antd";
import React, { createContext, useEffect, useState } from "react";
import classes from "./HomeScreen.module.css";
import {
  CatchMessage,
  CheckUserType,
  JSONtoformdata,
  MomentDateTime,
  getValidData,
  tokenisValid,
} from "../../Shared/Methods";
import { useLocation, useNavigate } from "react-router-dom";
import Devicemeter from "../../Components/Device/DeviceMeter";
import Devicealertsettings from "../../Components/Device/DeviceAlertSettings";
import CommonButton from "../../Components/Buttons/CommonButton";
import Inputpindetails from "../../Components/Device/InputPinDetails";
import Commontooltip from "../../Components/CommonTooltip/Commontooltip";
import UpdateRealyNameModal from "../../Modals/Device/UpdateRealyNameModal";
import editimg from "../../Assests/Images/pencil.png";
import { DeviceListData, ViewDeviceData } from "../../Services/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";

interface contextprops {
  item: any;
}

export const devicecontext = createContext<contextprops | null>(null);

function Viewdevice() {
  const location = useLocation();
  const { state } = location;
  const { item } = state || {};
  const navigate = useNavigate();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [isEditrelay, setEditRelay] = useState({ isView: false, item: "" });
  const dispatch = useDispatch();
  const [DeviceViewList, setDeviceViewList] = useState<any>();

  useEffect(() => {
    if (LoginData !== null && item?.deviceId !== "") {
      HandleViewDeviceData();
    }
  }, [LoginData, item]);

  const HandleViewDeviceData = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      deviceId: item?.deviceId,
    };

    ViewDeviceData(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          setDeviceViewList(res.data.data);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <devicecontext.Provider value={{ item: item }}>
        {isEditrelay?.isView ? (
          <UpdateRealyNameModal
            handleSuccess={() => {
              setEditRelay({ isView: false, item: "" });
              HandleViewDeviceData();
            }}
            item={DeviceViewList}
            open={isEditrelay.isView}
            closable={!isEditrelay?.isView}
            onCancel={() => {
              setEditRelay({ isView: false, item: "" });
            }}
          />
        ) : null}
        <div>
          <div className="header_container">
            <h3>Device Details</h3>
            <CommonButton
              name="Back"
              onClick={() => navigate("/device")}
              type="button"
              style={{ background: "red", fontSize: 17, maxWidth: 112 }}
              classname="back_button"
            />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            <Row gutter={[16, 16]}>
              <Col lg={12} md={12} sm={24}>
                <div className="primarycard h-100">
                  <p
                    style={{ marginBottom: "12px" }}
                    className="device_heading_style"
                  >
                    Device
                  </p>

                  <Row
                    className={classes.viewdevice_container}
                    gutter={[16, 3]}
                  >
                    <Col xl={8} lg={24} md={24} sm={8} xs={24}>
                      <div>
                        <h6>
                          Device Name :{" "}
                          <span>
                            {getValidData(DeviceViewList?.deviceName)}
                          </span>
                        </h6>

                        <h6>
                          Device Code :{" "}
                          <span>
                            {getValidData(DeviceViewList?.device_code)}{" "}
                          </span>
                        </h6>

                        {/* <h6>
                          Mac Address :{" "}
                          <span>{getValidData(DeviceViewList?.macAddress)}</span>
                        </h6> */}
                        {/* <h6>
                          IMEI Number :{" "}
                          <span>{getValidData(DeviceViewList?.imeiNumber)}</span>
                        </h6>
                        <h6>
                          Created At :{" "}
                          <span>
                            {getValidData(
                              DeviceViewList?.created_at
                                ? MomentDateTime(DeviceViewList?.created_at)
                                : null
                            )}
                          </span>
                        </h6> */}
                      </div>
                    </Col>

                    <Col xl={8} lg={24} md={24} sm={8} xs={24}>
                      <div>
                        <h6>
                          IMEI Number :{" "}
                          <span>
                            {getValidData(DeviceViewList?.imeiNumber)}
                          </span>
                        </h6>
                        <h6>
                          Mac Address :{" "}
                          <span>
                            {getValidData(DeviceViewList?.macAddress)}
                          </span>
                        </h6>
                      </div>
                    </Col>

                    <Col xl={8} lg={24} md={24} sm={8} xs={24}>
                      <div>
                        <h6>
                          Created At :{" "}
                          <span>
                            {getValidData(
                              DeviceViewList?.created_at
                                ? MomentDateTime(DeviceViewList?.created_at)
                                : null
                            )}
                          </span>
                        </h6>
                      </div>
                    </Col>

                    {/* <Col xl={12} lg={24} md={24}>
                      <p
                        style={{
                          paddingBottom: 4,
                          fontSize: 17,
                          fontWeight: 600,
                          color: "chocolate",
                        }}
                      >
                        Pin
                      </p>
                      <div>
                        {DeviceViewList?.pin_list?.map((ele: any) => {
                          return (
                            <h6
                              style={{
                                textAlign: "center",
                                // margin: 0,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <p className="device_pinname">{ele?.pin_name}</p>
                              &nbsp;:&nbsp;
                              <p
                                style={{
                                  color: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                {DeviceViewList?.pin_1_status ? "ON" : "OFF"}
                              </p>
                            </h6>
                          );
                        })}

                        <p
                          style={{
                            paddingBottom: 4,
                            fontSize: 17,
                            fontWeight: 600,
                            color: "chocolate",
                          }}
                        >
                          Relay
                        </p>

                        <h6>
                          {DeviceViewList?.relay1_name || "Relay One"} :{" "}
                          <span> {DeviceViewList?.relay1 ? "ON" : "OFF"}</span>
                        </h6>
                        <h6>
                          {DeviceViewList?.relay2_name || "Relay Two"} :{" "}
                          <span> {DeviceViewList?.relay2 ? "ON" : "OFF"}</span>
                        </h6>
                      </div>
                    </Col> */}
                    <Col xl={16} lg={16} md={24} sm={24} xs={24}>
                      <div
                        style={{
                          // background: "#cefffe",
                          background: "white",
                          padding: "10px",
                          borderRadius: "15px",
                          border: "1px solid #fdd9409e",
                          boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <p
                          style={{
                            color: "brown",
                            fontSize: 17,
                            fontWeight: 700,
                          }}
                        >
                          Input Pin
                        </p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            // flexFlow: "wrap",
                            gap: 10,
                          }}
                        >
                          {DeviceViewList?.pin_list?.length > 0 ? (
                            DeviceViewList?.pin_list?.map(
                              (ele: any, ind: number) => {
                                return (
                                  <h6
                                    style={{ textAlign: "center", margin: 0 }}
                                  >
                                    <Commontooltip
                                      children={
                                        <p className="device_pinname">
                                          {ele?.pin_name}
                                        </p>
                                      }
                                      msg={ele?.pin_name}
                                    />

                                    <p
                                      style={{
                                        color: "rgba(0, 0, 0, 0.5)",
                                        paddingTop: 5,
                                        fontWeight: 600,
                                        fontSize: 15,
                                      }}
                                    >
                                      {DeviceViewList[
                                        `pin_${ele?.pin_number}_status`
                                      ] === 1
                                        ? "ON"
                                        : "OFF"}
                                    </p>
                                  </h6>
                                );
                              }
                            )
                          ) : (
                            <>
                              <h6 style={{ textAlign: "center", margin: 0 }}>
                                <Commontooltip
                                  children={
                                    <p className="device_pinname">Pin 1</p>
                                  }
                                  msg="Pin 1"
                                />

                                <p
                                  style={{
                                    color: "rgba(0, 0, 0, 0.5)",
                                    paddingTop: 5,
                                    fontWeight: 600,
                                    fontSize: 15,
                                  }}
                                >
                                  {DeviceViewList?.pin_1_status === 1
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </h6>
                              <h6 style={{ textAlign: "center", margin: 0 }}>
                                <Commontooltip
                                  children={
                                    <p className="device_pinname">Pin 2</p>
                                  }
                                  msg="Pin 2"
                                />

                                <p
                                  style={{
                                    color: "rgba(0, 0, 0, 0.5)",
                                    paddingTop: 5,
                                    fontWeight: 600,
                                    fontSize: 15,
                                  }}
                                >
                                  {DeviceViewList?.pin_2_status === 1
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </h6>
                              <h6 style={{ textAlign: "center", margin: 0 }}>
                                <Commontooltip
                                  children={
                                    <p className="device_pinname">Pin 3</p>
                                  }
                                  msg="Pin 3"
                                />

                                <p
                                  style={{
                                    color: "rgba(0, 0, 0, 0.5)",
                                    paddingTop: 5,
                                    fontWeight: 600,
                                    fontSize: 15,
                                  }}
                                >
                                  {DeviceViewList?.pin_3_status === 1
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </h6>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col xl={8} lg={8} md={24} sm={24} xs={24}>
                      <div
                        style={{
                          // background: "rgb(206 255 224)",
                          background: "white",
                          padding: "10px",
                          borderRadius: "15px",
                          border: "1px solid #fdd9409e",
                          boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              color: "brown",
                              fontSize: 17,
                              fontWeight: 700,
                            }}
                          >
                            Relay
                          </p>
                          {CheckUserType() ? (
                            <Commontooltip
                              children={
                                <img
                                  src={editimg}
                                  onClick={() => {
                                    setEditRelay({
                                      isView: true,
                                      item: DeviceViewList,
                                    });
                                  }}
                                  style={{ width: "13px", height: "13px" }}
                                  alt="editimg"
                                />
                              }
                              msg="Update"
                            />
                          ) : null}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            // flexFlow: "wrap",
                            gap: 10,
                          }}
                        >
                          <h6 style={{ textAlign: "center", margin: 0 }}>
                            <Commontooltip
                              children={
                                <p className="device_pinname">
                                  {DeviceViewList?.relay1_name || "Relay One"}
                                </p>
                              }
                              msg={DeviceViewList?.relay1_name}
                            />

                            <p
                              style={{
                                color: "rgba(0, 0, 0, 0.5)",
                                paddingTop: 5,
                                fontWeight: 600,
                                fontSize: 15,
                              }}
                            >
                              {DeviceViewList?.relay1 === 1 ? "ON" : "OFF"}
                            </p>
                          </h6>

                          <h6 style={{ textAlign: "center", margin: 0 }}>
                            <Commontooltip
                              children={
                                <p className="device_pinname">
                                  {DeviceViewList?.relay2_name || "Relay Two"}
                                </p>
                              }
                              msg={DeviceViewList?.relay2_name}
                            />
                            <p
                              style={{
                                color: "rgba(0, 0, 0, 0.5)",
                                paddingTop: 5,
                                fontWeight: 600,
                                fontSize: 15,
                              }}
                            >
                              {" "}
                              {DeviceViewList?.relay2 === 1 ? "ON" : "OFF"}
                            </p>
                          </h6>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={12} md={12} sm={24}>
                <Inputpindetails HandleViewDeviceData={HandleViewDeviceData} />
              </Col>
            </Row>
            <Devicemeter />
            <Devicealertsettings item={item} />
          </div>
        </div>
      </devicecontext.Provider>
    </>
  );
}

export default Viewdevice;
